import { Loader2, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

// Skeleton yang meniru bentuk baris agar layout tidak melompat saat data tiba.
export function ListSkeleton({ rows = 4, testId = "list-skeleton" }) {
  return (
    <div data-testid={testId} aria-hidden className="overflow-hidden rounded-2xl border border-white/10 bg-zinc-900">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 border-b border-white/5 px-4 py-3.5 last:border-0">
          <div className="h-10 w-10 shrink-0 rounded-lg bg-white/5" />
          <div className="min-w-0 flex-1 space-y-2">
            <div className="h-3.5 w-2/5 rounded bg-white/5" />
            <div className="h-3 w-3/5 rounded bg-white/5" />
          </div>
          <div className="h-6 w-20 shrink-0 rounded-full bg-white/5" />
        </div>
      ))}
    </div>
  );
}

// Tiga keadaan kosong yang berbeda - bukan satu kotak abu generik.
export function EmptyState({ kind = "filtered", title, hint, action }) {
  const copy = {
    first: { t: title ?? "Belum ada data", h: hint ?? "Data akan muncul di sini setelah ada aktivitas." },
    filtered: { t: title ?? "Tidak ada hasil", h: hint ?? "Coba ubah kata kunci atau bersihkan filter." },
    zero: { t: title ?? "Semua beres", h: hint ?? "Tidak ada yang menunggu saat ini." },
  }[kind];
  return (
    <div data-testid={`empty-${kind}`} className="rounded-2xl border border-dashed border-white/15 px-6 py-10 text-center">
      <p className="text-sm font-medium text-zinc-300">{copy.t}</p>
      <p className="mx-auto mt-1 max-w-sm text-sm text-zinc-500">{copy.h}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

// Error selalu ErrorState - tidak pernah EmptyState. Bawa kode/penyebab + retry.
export function ErrorState({ message = "Gagal memuat data.", onRetry, testId = "error-state" }) {
  return (
    <div data-testid={testId} role="alert" className="rounded-2xl border border-rose-500/25 bg-rose-500/5 px-6 py-8 text-center">
      <p className="text-sm font-medium text-rose-300">Tidak bisa menampilkan data</p>
      <p className="mx-auto mt-1 max-w-md text-sm text-zinc-400">{message}</p>
      {onRetry && (
        <Button data-testid={`${testId}-retry`} variant="outline" onClick={onRetry}
          className="mt-4 h-11 rounded-full border-white/15 bg-transparent px-5 text-sm text-zinc-200 hover:bg-white/10">
          <RefreshCw className="mr-2 h-4 w-4" /> Coba lagi
        </Button>
      )}
    </div>
  );
}

// Refresh latar: data lama tetap tampil + indikator kecil. Tidak pernah blank.
export function Refreshing({ label = "Memperbarui" }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-zinc-500" role="status">
      <Loader2 className="h-3.5 w-3.5 animate-spin" /> {label}…
    </span>
  );
}
